// src/components/Query/QueryModal.tsx
//
// The query form presented as an application window.
//
// This file is the whole of the query-specific composition: which window, which
// title, and what happens when a send succeeds. ModalBox supplies the window,
// QueryForm supplies the form, and neither knows the other's business.
import ModalBox from '../ModalBox/ModalBox';

import QueryForm from './QueryForm';

export interface QueryModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const QueryModal = ({ isOpen, onClose }: QueryModalProps) => (
  <ModalBox isOpen={isOpen} onClose={onClose} title="Submit Your Query" size="md">
    {/*
      onSuccess closes the window, but only once SuccessModal has finished
      showing. The visitor sees the confirmation first, then the window shuts
      and focus returns to whatever opened it — which is the page they were
      already on. Nothing navigates.
    */}
    <QueryForm onSuccess={onClose} />
  </ModalBox>
);

export default QueryModal;
